<!-- Session Expiring Modal -->
<div class="modal fade" id="sessionExpiringModal" role="dialog">
  <div class="modal-dialog modal-md">

    <!-- Modal content-->
    <div class="modal-content">
      <!--<div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">&times;</button>
          <h4 class="modal-title">Session Expiring</h4>
      </div> -->
      <div class="modal-body">
        <br><img src="/assets/images/EF_logo.png" width="340">
        <br>
        <div id="sessionExpiringTime" style="font-size: 55px; font-weight: bold;">{{ minutesToExpiration }}:{{ secondsToExpiration | number: '2.0' }}</div>
        <p>To keep your account secure, we will log you out shortly...</p>
        <br>
        <button type="button" class="btn btn-default" style="margin-right: 5px" data-dismiss="modal" (click)="logoutOfSession()"><i class="fa fa-sign-out" aria-hidden="true"></i> LOG ME OUT</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="resetSession()"><i class="fa fa-clock-o" aria-hidden="true"></i> I'M STILL WORKING</button>
      </div>

      <!--<div class="modal-footer">

      </div> -->
    </div>
  </div>
</div>

<!-- Session Expired Modal -->
<div class="modal fade" id="sessionExpiredModal" role="dialog">
  <div class="modal-dialog modal-md">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-body">
        <br><img src="/assets/images/EF_logo.png" width="340">
          <br>
          <p style="font-size: 24px; font-weight: bold;">Looks like you left...</p>
          <p>For security purposes, we've logged you out of your session.
          <br>To get back into Edgefinity IoT, just log back in.</p>
          <br>
        <button type="button" class="btn btn-primary" data-dismiss="modal" (click)="logoutOfSession()"><i class="fa fa-sign-in" aria-hidden="true"></i> LOG BACK IN</button>
      </div>
    </div>

  </div>
</div>
